import { render } from "./RecentSubmissions.vue?vue&type=template&id=40c6b3f2&scoped=true"
import script from "./RecentSubmissions.vue?vue&type=script&lang=js"
export * from "./RecentSubmissions.vue?vue&type=script&lang=js"

import "./RecentSubmissions.vue?vue&type=style&index=0&id=40c6b3f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c6b3f2"]])

export default __exports__